export class CreateSurveyModal{
    constructor(
private surveyText:string,
private selectedQuestions:any[]



    ){}
}